import { createContext, useContext } from "react";

// Contexto compartilhado entre 2.3-circuito/index.js e o modal de aplicar template em massa
// (circuito/diagramaEquipamentos/templates/index.js), que fica no fim de uma cadeia profunda
// (serviceItem.js > circuito/index.js > diagramaEquipamentos/index.js > DiagramaCanvas/index.js
// > templates/index.js). Evita enfiar `servicos`/`bloqueadoPorPendencia` como prop por 3
// componentes intermediários que não têm nenhuma relação com a feature de aplicação em massa.
// `aplicarTemplateEmMassa` (Task 5) chama o service real e reidrata `forms` — vive aqui pelo
// mesmo motivo: só quem está em 2.3-circuito/index.js tem `reidratarCircuitosAplicados`.
const AplicarEmMassaContext = createContext({
	servicos: [],
	bloqueadoPorPendencia: false,
	aplicarTemplateEmMassa: async () => {},
	reapplySignal: 0,
});

// Hook de conveniência para consumir o contexto sem repetir useContext + o contexto em cada arquivo
export function useAplicarEmMassaContext() {
	return useContext(AplicarEmMassaContext);
}

export default AplicarEmMassaContext;
